import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading, null = anon
  const [token, setToken] = useState(() => localStorage.getItem("trvpro_token"));

  const refresh = useCallback(async () => {
    // Skip /auth/me if we're processing a Google OAuth callback (AuthCallback handles it)
    if (typeof window !== "undefined" && (window.location.hash || "").includes("session_id=")) {
      return;
    }
    if (!localStorage.getItem("trvpro_token")) { setUser(null); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("trvpro_token");
      setToken(null);
      setUser(null);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("trvpro_token", data.token);
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("trvpro_token", data.token);
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("trvpro_token");
    setToken(null); setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, token, login, register, logout, refresh, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
